module.exports = __webpack_public_path__ + "media/Lucky Dube-Teach the World.ce8c1328.mp3";